import { Component,OnInit, OnDestroy } from '@angular/core';
import { AlertService, AuthenticationService, UserService } from '../_services/index'
import { Router, ActivatedRoute } from '@angular/router';



@Component({
  
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  //styleUrls: ['./app.component.css']
})
/*export class FooterComponent {

}*/

export class FooterComponent {
year : any;
name:any="FoodBot";
copyRight:any="Copyright"

constructor(private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService) 
          { }
ngOnInit(){
	var d = new Date();
    this.year = d.getFullYear();
        let whitelabelSetting=JSON.parse(localStorage.getItem('whiteLabelSetting'))
        if(whitelabelSetting && whitelabelSetting.dashboard){
          let setting=whitelabelSetting.dashboard.settings.footer_text.replace(/{{year}}/g, this.year)
          let splitArray=setting.split(" ")
        this.copyRight=splitArray[0];
        splitArray.splice(0, 1);
        this.name=splitArray.join(" ")
        }
}

// test
	
}





// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/global/footer.component.ts